import { REGEX } from 'utils/regex'
import * as yup from 'yup'

// Messages are `auth` translation keys: render a field error with t(error.message).
export const signupSchema = yup.object().shape({
  name: yup
    .string()
    .required('auth:validation.firstNameRequired')
    .matches(REGEX.name, 'auth:validation.firstNameLetters')
    .min(2, 'auth:validation.firstNameMin')
    .max(25, 'auth:validation.firstNameMax'),

  email: yup.string().email('auth:validation.emailInvalid').required('auth:validation.emailRequired'),
})

export const loginSchema = yup.object().shape({
  email: yup.string().email('auth:validation.emailInvalid').required('auth:validation.emailRequired'),
})
